import { Box, Typography } from '@mui/material'
import { contactInfoCards } from '../../data/contactContent'
import FigmaIconFrame from '../common/FigmaIconFrame'
import {
  contactMobileCardBodySx,
  contactMobileCardTitleSx,
  contactMobileCardsGap,
} from './contactMobileLayout'

function ContactInfoCard({ title, lines, icon, iconBg }) {
  return (
    <Box
      sx={{
        flex: { md: '1 1 0', lg: '1 1 0' },
        minWidth: 0,
        bgcolor: '#fffefa',
        borderRadius: '20px',
        boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.12)',
        p: '24px',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 6, md: '50px' } }}>
        <FigmaIconFrame src={icon} bgColor={iconBg} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <Typography
            sx={{
              fontSize: { xs: 24, md: 28 },
              lineHeight: 'normal',
              fontWeight: 400,
              color: '#111',
              ...contactMobileCardTitleSx,
            }}
          >
            {title}
          </Typography>
          <Box>
            {lines.map((line) => (
              <Typography
                key={line}
                sx={{
                  fontSize: { xs: 16, md: 20 },
                  lineHeight: '24px',
                  fontWeight: 400,
                  color: 'rgba(17,17,17,0.6)',
                  ...contactMobileCardBodySx,
                }}
              >
                {line}
              </Typography>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default function ContactInfoCards() {
  return (
    <Box
      component="section"
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
        gap: { xs: '32px', md: '40px' },
        width: '100%',
        ...contactMobileCardsGap,
      }}
    >
      {contactInfoCards.map((card) => (
        <ContactInfoCard key={card.title} {...card} />
      ))}
    </Box>
  )
}
